import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedInstacartAccountTypeResponse, InstacartAccountQueryInput } from '@/models/instacartAccount';

export const fetchInstacartAccounts = async ({
  email,
  country,
  isClosed,
  orderBy,
  sortType,
  pagination,
}: InstacartAccountQueryInput): Promise<PaginatedInstacartAccountTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query InstacartAccounts(
        $email: String
        $country: InstacartCountry
        $isClosed: Boolean
        $orderBy: String
        $sortType: String
        $pagination: PaginationInputType
      ) {
        instacartAccounts(
          email: $email
          country: $country
          isClosed: $isClosed
          orderBy: $orderBy
          sortType: $sortType
          pagination: $pagination
        ) {
          rows {
            id
            isActive
            isClosed
            isEbtAccount
            user
            email
            phoneNumber
            country
            cookie
            csrfToken
            operatorId
            operator {
              firstName
              lastName
            }
            lastUsedAt
            lastLoginSuccess
            lastLoginFailure
            isLocked
            lockedAt
            createdAt
            updatedAt
            notes
          }
          count
        }
      }
    `),
    variables: {
      email,
      country,
      isClosed,
      orderBy,
      sortType,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.instacartAccounts;
};
